import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import CustomInput from "./CustomInput";
import DropDown from "./DropDown";
import { Modal } from "antd";
import { onecodeAPI } from "../AppConfig";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { LoadingOutlined,CloseOutlined} from "@ant-design/icons";
import moment from "moment";
import "./CustomerFormStyle.css";
import { isCharWithoutSymbol } from "../utils/regexConstants";

export default function BackfillModal({
  additionalFields,
  customerDetails,
  searchParams,
  dropDownOptions,
  pincodeList,
  setPinCodeList,
  setCustomerDetails
}) {
  const { t, i18n } = useTranslation();

  const [submitLoading, setSubmitLoading] = useState(false);
  const [searchedPincodeList, setSearchedPincodeList] = useState([]);
  const [
    isModalVisibleForAdditionalFields,
    setIsModalVisibleForAdditionalFields,
  ] = useState(true);

  const handleCancel = () =>{
    setIsModalVisibleForAdditionalFields(false);
  }

  const [selectedEmploymentType, setSelectedEmploymentType] = useState(
    customerDetails.employmentType
  );
  let addRegex = {};
  const numberReg = /^[1-9]{1}[0-9]{5}$/;
  additionalFields.forEach((f) => {
    let mf = f == "pincodePan" ? "pinCode" : f;
    addRegex = {
      ...addRegex,
      [mf]:
        Yup.string().matches(isCharWithoutSymbol, "Special characters not allowed").required("Required"),
    };
  });
  const conditionalValidation = {
    employerName:
      selectedEmploymentType !== "Not Working"
        ? Yup.string().required("Required")
        : Yup.string().nullable(),
    workExperience:
      selectedEmploymentType !== "Not Working"
        ? Yup.string().required("Required")
        : Yup.string(),
    annualIncome:
      selectedEmploymentType !== "Not Working"
        ? Yup.string().required("Required")
        : Yup.string().nullable(),
    currentOccupation:
      selectedEmploymentType !== "Not Working"
        ? Yup.string().required("Required")
        : Yup.string().nullable(),
    modeOfIncome:
      selectedEmploymentType !== "Not Working"
        ? Yup.string().required("Required")
        : Yup.string().nullable(),
  };

  const generateConditionalValidation = () => {
    let reqCondtional = {};
    _.forEach(additionalFields, (af) => {
      if (
        [
          "employerName",
          "workExperience",
          "annualIncome",
          "currentOccupation",
          "incomeMode",
          "modeOfIncome",
        ].includes(af)
      ) {
        reqCondtional[af] = conditionalValidation[af];
      }
    });
    return reqCondtional;
  };

  const makeFieldDisabled = (f) => {
    if (
      [
        "employerName",
        "workExperience",
        "annualIncome",
        "currentOccupation",
        "incomeMode",
        "modeOfIncome",
      ].includes(f) &&
      selectedEmploymentType == "Not Working"
    ) {
      return true;
    }
    return false;
  };

  generateConditionalValidation();
  const customerSchema = Yup.object().shape({
    ...addRegex,
    ...generateConditionalValidation(),
  });
 
  const formik = useFormik({
    initialValues: {},
    validationSchema: customerSchema,

    onSubmit: async (values) => {
      setSubmitLoading(true);
      var dateOfBirth = null;
      if (values.dob) {
        dateOfBirth = moment(values.dob).format("YYYY/MM/DD kk:mm:ss");
      }
      let customerObj = {
        phoneNumber: customerDetails.phoneNumber,
        ...values,
        pinCodePan: values.pinCode || customerDetails.pincodePan,
        dateOfBirth: values.dateOfBirth || values.dob,
      };
      let hash = encodeURIComponent(searchParams.get("hash"));
      try {
        let response = await onecodeAPI.post("/public/customer/edit", {
          hash: hash,
          customer: customerObj,
        });
        setCustomerDetails({...customerDetails,...customerObj});
        setIsModalVisibleForAdditionalFields(false);
        setSubmitLoading(false);
        window.location.reload(false)
      } catch (error) {
        console.log(error);
        setSubmitLoading(false);
      }
    },
  });
  return (
    <>
      <Modal
        visible={isModalVisibleForAdditionalFields}
        footer={false}
        closable={false}
        onCancel={()=>
          handleCancel()}
      >

            <CloseOutlined
                className="modalCloseBtn"
                onClick={handleCancel}
                style={{
                  backgroundColor: "#fff",
                  alignSelf: "flex-end",
                  padding: "5px",
                  borderRadius: "25px",
                  position: "absolute",
                  top: "35px",
                  right: "20px",
                }}
              />


        <p
          style={{
            marginTop: 10,
            paddingLeft: 20,
            fontSize: 16,
            fontWeight: "bold",
            color: "black",
          }}
        >
          Confirm the below details
        </p>
        <form
          onSubmit={formik.handleSubmit}
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          {additionalFields.map((f) => {
            if (f == "dob") {
              return (
                <div
                  style={{
                    margin: "0",
                    width: "100%",
                    marginBottom: "5px",
                  }}
                >
                  <CustomInput
                    label={t("addcustomertotalinformation.dob")}
                    type="date"
                    handleChange={formik.handleChange}
                    handleBlur={formik.handleBlur}
                    value={formik.values.dob}
                    name="dob"
                    readonly={false}
                  />
                  {formik.touched.dob && formik.errors.dob ? (
                    <div className="error">{formik.errors.dob}</div>
                  ) : null}
                </div>
              );
            } else if (f == "panNo") {
              return (
                <div
                  style={{
                    margin: "0 auto",
                    width: "90%",
                    marginBottom: "5px",
                    marginLeft: "2.7%",
                  }}
                >
                  <CustomInput
                    label={t("addcustomertotalinformation.pannumber")}
                    handleChange={formik.handleChange}
                    handleBlur={formik.handleBlur}
                    value={formik.values.pan}
                    name="pan"
                    readonly={false}
                  />
                  {formik.touched.pan && formik.errors.pan ? (
                    <div
                      className="error"
                      style={{ paddingLeft: "17px", marginBottom: "-10px" }}
                    >
                      {formik.errors.pan}
                    </div>
                  ) : null}
                </div>
              );
            } else if (f == "pincodePan") {
              return (
                <div
                  style={{
                    margin: "0",
                    width: "100%",
                    marginBottom: "5px",
                  }}
                >
                  <CustomInput
                    label={t("addcustomertotalinformation.pincode")}
                    handleChange={(option) => {
                      formik.setFieldValue("pinCode", option);
                    }}
                    handleBlur={formik.handleBlur}
                    value={formik.values.pinCode}
                    name="pinCode"
                    readonly={false}
                    text="number"
                    setSearchedPincodeList={setSearchedPincodeList}
                  />
                  {formik.errors.pinCode ? (
                    <div className="error">{formik.errors.pinCode}</div>
                  ) : null}
                </div>
              );
            } else if (
              [
                "currentOccupation",
                "workExperience",
                "annualIncome",
                "modeOfIncome",
              ].includes(f) &&
              selectedEmploymentType != "Not Working"
            ) {
              return (
                <>
                  <DropDown
                    label={
                      dropDownOptions ? dropDownOptions[f]?.label : "label"
                    }
                    data={dropDownOptions ? dropDownOptions[f]?.options : []}
                    handleBlur={formik.handleBlur}
                    value={formik.values[f]}
                    name={f}
                    handleChange={(option) => {
                      if (f == "employmentType") {
                        setSelectedEmploymentType(option.value);
                      }
                      formik.setFieldValue(f, option.value);
                    }}
                    disable={makeFieldDisabled(f)}
                  />

                  {formik.errors[f] ? (
                    <div className="error">{formik.errors[f]}</div>
                  ) : null}
                </>
              );
            } else if (f == "gender" || f == "employmentType") {
              return (
                <>
                  <DropDown
                    label={
                      dropDownOptions ? dropDownOptions[f]?.label : f
                    }
                    data={dropDownOptions ? dropDownOptions[f]?.options : []}
                    handleBlur={formik.handleBlur}
                    value={formik.values[f]}
                    name={f}
                    handleChange={(option) => {
                      formik.setFieldValue(f, option.value);
                    }}
                  />
                  {formik.errors[f] ? (
                    <div className="error">{formik.errors[f]}</div>
                  ) : null}
                </>
              );
            } else if (
              [
                "fullName",
                "phoneNumber",
                "email",
                "employerName",
              ].includes(f)
            ) {
              return (
                <>
                  <CustomInput
                    label={dropDownOptions ? dropDownOptions[f]?.label : f}
                    handleChange={
                      f == "employerName"
                        ? (option) => {
                            formik.setFieldValue(f, option);
                          }
                        : formik.handleChange
                    }
                    handleBlur={formik.handleBlur}
                    value={formik.values[f]}
                    name={f}
                  />
                  {formik.touched[f] && formik.errors[f] ? (
                    <div className="error">{formik.errors[f]}</div>
                  ) : null}
                </>
              );
            }
          })}
          <button
            onClick={() => formik.handleSubmit()}
            style={{
              background: "#6C63FF",
              border: "none",
              color: "white",
              padding: 12.5,
              borderRadius: 5,
              margin: "auto",
              width: "85%",
              marginTop: "10px",
            }}
          >
            {submitLoading ? <LoadingOutlined size={"large"} /> : null}
            {t("addcustomertotalinformation.Apply")}
          </button>
        </form>
      </Modal>
    </>
  );
}
